import React, { useEffect, useMemo, useState } from "react";
import Text from 'theme/Text'
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import i18n from "utils/i18n";
import ThemedBlock from 'components/atoms/ThemedBlock'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import _ from 'lodash'
import * as Linking from 'expo-linking'
import * as Clipboard from 'expo-clipboard';
import { textStyles } from 'styles/text'
import Button from "theme/Button";
import { TESTID } from '_shared/config/testID'
import { openUrl } from 'utils/helper-url'
import Calendar from 'utils/calendar'
import VStack from 'components/atoms/stack/VStack'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import HelperPlatform from 'utils/helper-platform'

const HomeMoreAboutCalendarSubscription = () => {

	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	
	const [ calendarList, setCalendarList ] = useState( [] );

	const url = useMemo( () => {
		return _.get( _employee, 'ics_url', null );
	}, [ _employee ] );

	const canOpenUrl = async ( url ) => {
		return Linking.canOpenURL( url );
	}

	const handleCopy = () => {
		Clipboard.setStringAsync( url );
	}

	const handleOpenCalendar = async ( item ) => {
		openUrl( item.url )
	}
	
	useEffect( () => {
		( async() => {
			const items = [
				{
					name: 'Outlook',
					icon: IconSystemConstants.OUTLOOK,
					url: Calendar.url.outlook( url )
				},
				{
					name: 'Google',
					icon: IconSystemConstants.GOOGLE,
					url: Calendar.url.google( url )
				},
			]
			
			if( HelperPlatform.isNative() ) {
				items.push({
					name: '',
					icon: IconSystemConstants.MOBILE_PHONE,
					url: url
				});
			}
			
			const result = [];
			for( const item of items ) {
				if( item.url !== null && await canOpenUrl( item.url ) ) {
					result.push( item );
				}
			}
			
			setCalendarList( result );
		})()
	}, [ url ] );
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>

			<ThemedLayout
				title={ i18n.t('titles.more_calendar_subscription') }
				topNavigation={ true }
				showBackButton={ true }
				testID={ TESTID.HOME.MORE.SCREENS.CALENDAR_SUBSCRIPTION}>

				<ThemedBlock mediumPadding shadow>
					<VStack>
						<Text
							style={ textStyles.textCenter }>
							
							{i18n.t( 'page.booking_subscription.explanation')}
						</Text>
						
						<VStack>
							{ _.map( calendarList, ( item, index ) => {
								return (
									<Button
										icon={ <Icon icon={ item.icon } color={'white'} /> }
										onPress={ handleOpenCalendar.bind( this, item ) }>
										
										{ i18n.t( 'page.booking_subscription.button', {
											name: item.name
										}) }
									</Button>
								)
							}) }
		
							<Button
								appearance="ghost"
								onPress={ handleCopy }>
								
								{ i18n.t( 'page.booking_subscription.button_copy') }
							</Button>
						</VStack>
					</VStack>
				</ThemedBlock>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)

}

export default HomeMoreAboutCalendarSubscription;
